<template>
  <div class="personal">
    <div class="personallTit">
      <p>个人资料</p>
    </div>
    <div class="personalCon">
      <p>账号：{{ personal.username }}</p>
      <p>真实姓名：{{ personal.nickname }}</p>
      <p>岗位：{{ personal.groupName }}</p>
      <p>手机号：{{ personal.phone }}</p>
      <p>邮箱：{{ personal.email }}</p>
      <p>上级：{{ personal.pName }}</p>
      <p>团队：{{ personal.teamName }}</p>
      <p>能否分配佣金：{{ personal.is_can_commission == 0 ? "否" : "能" }}</p>
      <p>
        是否开放产品：<span v-if="personal.is_open_product == 0">否</span>
        <span v-else>是</span>
      </p>
    </div>
  </div>
</template>
<script>
import { getAdminInfo } from "@/api/user";
export default {
  name: "user",
  data() {
    return {
      personal: ""
    };
  },
  mounted() {
    this.getAdminInfo();
  },
  methods: {
    getAdminInfo() {
      let _id = this.$store.getters.id;
      console.log(_id);
      let that = this;
      let _data = { aid: _id };
      getAdminInfo(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.personal = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.personal {
  .personallTit {
    margin-top: -30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    p {
      font-size: 18px;
      font-weight: 400;
      color: #000000;
      line-height: 25px;
      margin: 0;
      margin-left: -24px;
    }
    p:before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 24px;
      background: #2d8aee;
      border-radius: 0px 10px 10px 0px;
      vertical-align: middle;
      position: relative;
      top: -2px;
      margin-right: 15px;
    }
  }
  .personalCon {
    padding: 20px 10px;
    p {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 40px;
      margin: 0;
      span {
        color: rgba(255, 0, 0, 0.85);
      }
    }
  }
}
</style>
